import type { IPerson } from '../model/IPerson'
import { getAge } from './getAge'

export function diedAsInfant(person: IPerson) {
	return (
		person.deathDate &&
		(getAge(person.birthDate, person.deathDate) ?? Infinity) < 2
	)
}
